var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgProductionBeltTime(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "-0.5 -0.5 14 14",
    height: 14,
    width: 14,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "production-belt-time--production-time-produce-box-clock-belt-factory"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector 248",
    fill: "#ffffff",
    d: "M3.536 4.722714285714286C4.587142857142858 3.7885714285714287 5.239000000000001 3.4728571428571433 6.5 3.240714285714286c1.2610000000000001 0.23307142857142857 1.912857142857143 0.5478571428571428 2.9640000000000004 1.4820000000000002L6.5 6.204714285714286 3.536 4.722714285714286Z",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 251",
    stroke: "#f97316",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M3.536 4.722714285714286C4.587142857142858 3.7885714285714287 5.239000000000001 3.4728571428571433 6.5 3.240714285714286c1.2610000000000001 0.23307142857142857 1.912857142857143 0.5478571428571428 2.9640000000000004 1.4820000000000002",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Subtract",
    fill: "#fdba74",
    d: "M3.536 4.722714285714286c-0.36492857142857144 1.002857142857143 -0.36864285714285716 2.198857142857143 -0.07892857142857143 3.2063571428571427a0.8617142857142858 0.8617142857142858 0 0 0 0.2785714285714286 0.4215714285714286c0.9174285714285715 0.7651428571428571 1.5442142857142858 1.0465 2.5684285714285715 1.2702857142857145a0.9285714285714286 0.9285714285714286 0 0 0 0.39185714285714285 0c1.0232857142857144 -0.22378571428571428 1.651 -0.5051428571428572 2.5675000000000003 -1.2702857142857145a0.8617142857142858 0.8617142857142858 0 0 0 0.2795 -0.4215714285714286c0.2897142857142857 -1.0075 0.28600000000000003 -2.2035000000000005 -0.07892857142857143 -3.2063571428571427L6.5 6.204714285714286 3.536 4.722714285714286Z",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Subtract_2",
    stroke: "#f97316",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M3.536 4.722714285714286c-0.36492857142857144 1.002857142857143 -0.36864285714285716 2.198857142857143 -0.07892857142857143 3.2063571428571427a0.8617142857142858 0.8617142857142858 0 0 0 0.2785714285714286 0.4215714285714286c0.9174285714285715 0.7651428571428571 1.5442142857142858 1.0465 2.5684285714285715 1.2702857142857145a0.9285714285714286 0.9285714285714286 0 0 0 0.39185714285714285 0c1.0232857142857144 -0.22378571428571428 1.651 -0.5051428571428572 2.5675000000000003 -1.2702857142857145a0.8617142857142858 0.8617142857142858 0 0 0 0.2795 -0.4215714285714286c0.2897142857142857 -1.0075 0.28600000000000003 -2.2035000000000005 -0.07892857142857143 -3.2063571428571427L6.5 6.204714285714286 3.536 4.722714285714286Z",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 250",
    stroke: "#f97316",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M6.5 6.197285714285715v3.4645",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Ellipse 141",
    stroke: "#f97316",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M0.6964285714285714 6.5A5.803571428571429 5.803571428571429 0 0 1 11.607142857142858 3.741214285714286c0.07057142857142858 -1.0232857142857144 0.04921428571428572 -1.6082857142857143 -0.09285714285714286 -2.669642857142857",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Ellipse 142",
    stroke: "#f97316",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M12.303571428571429 6.5a5.803571428571429 5.803571428571429 0 0 1 -10.895857142857142 2.7857142857142856c-0.07057142857142858 1.022357142857143 -0.05014285714285714 1.6082857142857143 0.09285714285714286 2.669642857142857",
    strokeWidth: 1
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgProductionBeltTime);
export default __webpack_public_path__ + "static/media/production-belt-time.1e1d7895a5a1e343309ab3086af0efcc.svg";
export { ForwardRef as ReactComponent };